export default __webpack_public_path__ + "static/media/business.4b5b9189.svg";